import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../context/app-context';
import { CustomButton } from '../elements/button';
import { getEntryPointRoute } from '../utils/get-entry-point-route';

export const GlobalHomeButton = () => {
  const { venueType, store, selectedVendor } = useContext(AppContext);
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);

  return (
    <CustomButton
      title={t('common.home')}
      style={{ height: '48px' }}
      onClick={() =>
        navigate(
          getEntryPointRoute(
            venueType?.value || '',
            store?.value,
            selectedVendor?.value?._id,
          ),
        )
      }
    />
  );
};
